import { render, staticRenderFns } from "./ConsumeModel.vue?vue&type=template&id=7132e2ba&scoped=true"
import script from "./ConsumeModel.vue?vue&type=script&lang=js"
export * from "./ConsumeModel.vue?vue&type=script&lang=js"
import style0 from "./ConsumeModel.vue?vue&type=style&index=0&id=7132e2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7132e2ba",
  null
  
)

export default component.exports